import { Component, OnInit } from '@angular/core';
import { map } from 'rxjs/operators';
import { DealModel } from 'src/app/models/deal.model';
import { DealsService } from 'src/app/services/deals.service';
import { PerformanceReportService } from 'src/app/services/report/performance-report.service';
import { DealPipelineWorkflowService } from 'src/app/services/settings-services/deal-pipeline-workflow.service';
import DateUtils from 'src/app/utils/date';

@Component({
  selector: 'app-deal-per-by-stage',
  templateUrl: './deal-per-by-stage.component.html',
  styleUrls: ['./deal-per-by-stage.component.css']
})
export class DealPerByStageComponent implements OnInit {
  showChart = false;
  dateUtil = new DateUtils;
  dateRange = {startDate: null, endDate: null};
  workflows$;
  selectedIds = null;
  selectedType = null;
  selectedWorkflow = '';
  dateType = '90';
  

  chartOptions = {
    series: [],
    chart: {
      width: 300,
      type: "pie"
    },
    labels: [],
    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: {
            width: 170
          },
          legend: {
            position: "bottom"
          }
        }
      }
    ]
  };
  constructor(
    private dealSrv: DealsService,
    private performRepSrv: PerformanceReportService,
    private dealWorkflow: DealPipelineWorkflowService) { 
    this.dateRange = this.dateUtil.getDefReportDateRange(Number(this.dateType));
    this.workflows$ = this.dealWorkflow.getDealsPipelineWorkflow();
    this.performRepSrv.selected_users.subscribe(res => {
      if(res && res.type) {        
        const { ids, type } = res;
        this.selectedIds = ids;
        this.selectedType = type;
        this.getData()
      }
    })
  }

  ngOnInit() {
    this.getData()
  }
  dateChange({dateRange, dateType}) {
    this.dateRange = dateRange;
    this.dateType = dateType;
    this.getData();
  }
  getData() {
    this.showChart = false;
    let filter: any = {status: 'WON', dateFilter: this.dateRange};
    if(this.selectedType === 'salesperson') {
      filter = {...filter, salesPerson: {ids: this.selectedIds}}
    };
    
    this.dealSrv.fetchDeals(this.selectedIds, filter).pipe(map((deals: DealModel[]) => {
      return deals.filter(deal => deal.salesProcessID === this.selectedWorkflow).map(deal => {
        const lastStageNameBeforeClose = deal.lastStageNameBeforeClose ? deal.lastStageNameBeforeClose : 'Others'
        return {...deal, lastStageNameBeforeClose}
      })
    })).subscribe(res => {
      this.manipulateData(res);
    })
  }
  manipulateData(deals: DealModel[]) {
    const stages = {};
    deals.forEach((deal) => {
      if(stages[deal.lastStageNameBeforeClose]){
        let stageCount = stages[deal.lastStageNameBeforeClose];
        stageCount = stageCount + 1;
        stages[deal.lastStageNameBeforeClose] = stageCount
      } else {
        stages[deal.lastStageNameBeforeClose] = 1
      }
    });
    const series =  [], labels = []
    Object.keys(stages).forEach(field => {
      series.push(stages[field])
      labels.push(field)
    })
    
    this.chartOptions.series = series;
    this.chartOptions.labels = labels
    this.showChart = true
  }


}
